export * from './award.model';
export * from './award.service';
export * from './award-form.service';


// WEBPACK FOOTER //
// ./libs/atenea-cms-brand/src/awards/shared/index.ts